import {
  GET_ESTADISTICAS,
  GET_ESTADISTICAS_SUCCESS,
  GET_ESTADISTICAS_ERROR,
  SET_PERIODO_ESTADISTICAS,
  EstadisticasState,
  initialState,
  EstadisticasActions,
} from './types'

const EstadisticasReducer = (
  state: EstadisticasState = initialState,
  action: EstadisticasActions | undefined = undefined
): EstadisticasState => {
  switch (action?.type) {
    case GET_ESTADISTICAS:
      return {
        ...state,
        loading: true,
        error: false,
      }
    case GET_ESTADISTICAS_SUCCESS:
      return {
        ...state,
        estadisticas: action.payload,
        loading: false,
        error: false,
      }
    case GET_ESTADISTICAS_ERROR:
      return {
        ...state,
        estadisticas: null,
        loading: false,
        error: true,
      }
    case SET_PERIODO_ESTADISTICAS:
      return {
        ...state,
        periodo: action.payload.period,
        ...(action.payload.range ? { range: action.payload.range } : {}),
      }
    default:
      return state
  }
}
export default EstadisticasReducer
